import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    duration: { type: Number, default: 5000 },
  };

  connect() {
    this.timeout = setTimeout(() => {
      this.dismiss();
    }, this.durationValue);
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  dismiss() {
    this.element.remove();
  }
}
